import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    ASE: {
        id: 'form.type.domain.ase',
        defaultMessage: 'After Sales Engineering'
    },
    MR_TM_ASE: {
        id: 'form.type.ase.mrMt',
        defaultMessage: 'Repair Method and Labor Time Request'
    },
    EASY_BASKET: {
        id: 'form.type.ase.easyBasket',
        defaultMessage: 'Easy Basket'
    },
    ASE_INTERNAL_TICKET: {
        id: 'form.type.ase.internalRepairTicket',
        defaultMessage: 'Repair method / Labor Time Ticket'
    },
    ASE_INTERNAL_MAINTENANCE_TICKET: {
        id: 'form.type.ase.internalMaintenanceTicket',
        defaultMessage: 'Maintenance Ticket'
    },
    ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET: {
        id: 'form.type.ase.internalTechnicalBulletinTicket',
        defaultMessage: 'Technical Bulletin Ticket'
    },
});

export default messages;
